module.exports = __webpack_public_path__ + "img/sp2.f0d3b563.png";